import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './header.css';

import logo from 'assets/images/dashboard-logo.png';
import chevron from 'assets/images/menu-nav-chevron.svg';
import mobileMenuIcon from 'assets/images/sprite.svg';

import { useTranslation } from 'react-i18next';

import getVersion from 'utils/version';

import GetStarted from '../GetStarted/index';

function HeaderView(props) {
  const toggleMenu = () => {
    const body = document.getElementsByTagName('body')[0];

    if (body.classList.contains('menu-shown') === false) {
      body.classList.add('menu-shown');
    } else {
      body.classList.remove('menu-shown');
    }
  };

  const { t } = useTranslation();

  const location = useLocation();

  if (location.pathname.includes('password')) {
    return null;
  }

  const landingsURL = process.env.REACT_APP_LANDINGS_URL;

  const onGiftClick = () => {
    const body = document.getElementsByTagName('body')[0];

    body.classList.remove('menu-shown');
  };

  const LinkToSelectGoalcard = (
    <Link
      onClick={onGiftClick}
      to={{ pathname: '/selectgoalcard', state: { receiverGoal: props.selectedGoal, receiverUser: props.receiverUser } }}
      style={{ fontWeight: 'bold', color: '#F3A802' }}
    >
      {t('header_give_gift_title')}
    </Link>
  );

  const LinkToGift = (
    <a href="/gift" className="link-to-gift" style={{ fontWeight: 'bold', color: '#F3A802' }}>
      {t('header_give_gift_title')}
    </a>
  );

  return (
    <>
      <nav className="top-nav" alt={getVersion()}>
        <div className="top-nav-container">
          <div className="logo">
            <a href={landingsURL}>
              <img alt="logo" className="image-responsive" src={logo} />
            </a>
          </div>
          <div className="top-nav-menu mobile">
            <ul className="menu-nav main-menu">
              <li className="main-menu-item">
                <a href="/#" className="menu-dropdown">About</a>
                <span><img className="menu-nav-chevron" src={chevron} alt="chevron icon"></img></span>
                <ul className="desktop-dropdown">
                  <li><a href={`${landingsURL}/about`}>Our Team</a></li>
                  <li><a href={`${landingsURL}/contact-us`}>Contact Us</a></li>
                </ul>
                <ul className="mobile-dropdown">
                  <li>
                    <a href={`${landingsURL}/about`}>Our Team</a>
                  </li>
                  <li><a href={`${landingsURL}/contact-us`}>Contact Us</a></li>
                </ul>
              </li>
              <hr className="solid" />
              <li className="main-menu-item">
                <a href="/#" className="menu-dropdown">Features</a>
                <span><img className="menu-nav-chevron" src={chevron} alt="chevron icon"></img></span>
                <ul className="desktop-dropdown">
                  <li><a href={`${landingsURL}/financial-services`}>Goalsetter App</a></li>
                </ul>
                <ul className="mobile-dropdown">
                  <li><a href={`${landingsURL}/financial-services`}>Goalsetter App</a></li>
                </ul>
              </li>
              <hr className="solid" />
              <li className="main-menu-item">
                <a href="/#" className="menu-dropdown">Partners</a>
                <span><img className="menu-nav-chevron" src={chevron} alt="chevron icon"></img></span>
                <ul className="desktop-dropdown">
                  <li><a href={`${landingsURL}/educators`}>Educators</a></li>
                  <li><a href={`${landingsURL}/employers`}>Employers</a></li>
                </ul>
                <ul className="mobile-dropdown">
                  <li><a href={`${landingsURL}/educators`}>Educators</a></li>
                  <li><a href={`${landingsURL}/employers`}>Employers</a></li>
                </ul>
              </li>
              <hr className="solid" />
              <li className="main-menu-item">
                <a href="/#" className="menu-dropdown">Help Center</a>
                <span><img className="menu-nav-chevron" src={chevron} alt="chevron icon"></img></span>
                <ul className="desktop-dropdown">
                  <li><a href={`${landingsURL}/faq`}>FAQ'S</a></li>
                </ul>
                <ul className="mobile-dropdown">
                  <li><a href={`${landingsURL}/faq`}>FAQ'S</a></li>
                </ul>
              </li>
              <hr className="solid" />

              <li className="main-menu-item" style={{ opacity: 1 }}>
                <div className="active-tab">●</div>
                <span className="flex-active-tab">
                  <span className="mobile-dropdown"><span className="active-tab">●</span></span>
                  {
                    (props.selectedGoal || props.receiverUser) ? LinkToSelectGoalcard : LinkToGift
                  }
                </span>
              </li>

            </ul>
            <div className="top-nav-buttons">
              <div className="hero-container container hero-buttons">
                <GetStarted />
              </div>
            </div>
          </div>
          <div className="burger-menu">
            <button
              onClick={toggleMenu}
              id="mobileMenu"
              style={{ backgroundImage: `url(${mobileMenuIcon})` }}
              type="button"
              className="burger-menu-button"
              aria-label="mobile menu button"
            />
          </div>
        </div>
      </nav>
    </>
  );
}

const mapStateToProps = (state) => ({
  selectedGoal: state.publicProfile.goal,
  receiverUser: state.publicProfile.information,
});

export default connect(
  mapStateToProps,
  {},
)(HeaderView);
